import { Swiper } from './swiper';

const quoteSlider = document.querySelectorAll('.quote-slider .quote-slider__slide')

if ( quoteSlider.length > 0 ) {
    if (quoteSlider.length < 2) {
        document.querySelector('.quote-slider').classList.add('not-active')
    } else {
        const quoteSwiper = new Swiper('.quote-slider__container', {
            loop: true,
            navigation: {
                nextEl: ".quote-slider-next",
                prevEl: ".quote-slider-prev",
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
        });
    }
}




